
  export const ESTIMACIONESTADOALERTAS_RECEIVED = "ESTIMACIONESTADOALERTAS_RECEIVED";
  export const SET_ESTIMACIONESTADOALERTA = "SET_ESTIMACIONESTADOALERTA";
  export const CREATE_ESTIMACIONESTADOALERTA = "CREATE_ESTIMACIONESTADOALERTA";
  export const SET_PROPERTY_ESTIMACIONESTADOALERTA = "SET_PROPERTY_ESTIMACIONESTADOALERTA";
  